import { TShopifyApp } from 'redux/reducers/shopifyApps/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';

export const tableStructure: TTableStructure<keyof TShopifyApp, TShopifyApp>[] = [
	/**
	 * Hidden column that makes a click on the row open the app page:
	 * `EasRow` resolves the row link from the first column of the `LINK` type.
	 */
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'App Name',
		selector: 'name',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'API Key',
		selector: 'apiKey',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions' as keyof TShopifyApp,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				label: 'Show Stores',
				name: 'showStores',
			},
		],
	},
];
